// import FileSaver from "file-saver";
import constants from "../common/constants";
import { logout } from "../features/auth/authSlice";
import {
  clearSession,
  clearSessionKey,
  getRefreshToken,
  getSession,
} from "./SessionManager";
var CryptoJS = require("crypto-js");
//import vCardsJS from 'vcards-js';

const salt = process.env.REACT_APP_CLIENT_KEY;

var key = CryptoJS.enc.Utf8.parse(salt);
var randomNo = CryptoJS.SHA256(key);
randomNo = CryptoJS.lib.WordArray.create(randomNo.words.slice(0, 16 / 4));

export const handleLogOut = async (dispatch, navigate) => {
  // Dispatch logout to invalidate server token
  // Wrap in try-catch to handle API errors gracefully
  try {
    await dispatch(logout(getRefreshToken(window)));
  } catch (error) {
    // Silently handle logout API errors - we still want to clear session and navigate
    console.log(
      "Logout API call failed, but continuing with client-side cleanup",
      error
    );
  }

  // Clear auth error state to prevent "Failed to logout" snackbar
  // Import clearError from authSlice if needed
  dispatch({ type: "auth/clearError" });

  // Clear all client‑side session data
  window.sessionStorage.clear();
  clearSession(window);
  clearSessionKey(window, constants.SS_KEY_GROUP_ACCESS_TOKEN);
  sessionStorage.clear();
  localStorage.clear();
  console.log("session", sessionStorage);
  // Immediate navigation to login page
  navigate("/login");
};
export const priorityList = ["High", "Medium", "Low"];

export const validateAPI = (statusCode, errorCode, dispatch, navigate) => {
  if (errorCode === "INVALID_USER" && statusCode === 401) {
    handleLogOut(dispatch, navigate);
  }
};

const encryptObject = (reqObj) => {
  reqObj = encryptData(JSON.stringify(reqObj));
  let finalObj = {
    data: reqObj,
  };
  return finalObj;
};

const encryptData = (data) => {
  let result = CryptoJS.AES.encrypt(data, randomNo, {
    iv: randomNo,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return result.toString();
};

const decryptData = (data) => {
  let result = CryptoJS.AES.decrypt(data, randomNo, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return result.toString(CryptoJS.enc.Utf8);
};

const decryptObject = (encryptedObj) => {
  try {
    const decryptedStr = decryptData(encryptedObj.data);
    return JSON.parse(decryptedStr);
  } catch (error) {
    console.error("Failed to decrypt object:", error);
    return null;
  }
};

const formatDateTime = (dateString) => {
  const strDate = String(dateString);
  const cleanDate = strDate.split(".")[0];
  const date = new Date(cleanDate);

  const pad = (num) => String(num).padStart(2, "0");

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = date.getFullYear();

  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

const formatDate = (dateString, format) => {
  const strDate = String(dateString);
  const cleanDate = strDate.split(".")[0];
  const date = new Date(cleanDate);

  const pad = (num) => String(num).padStart(2, "0");

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = date.getFullYear();

  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  if (format === "YYYY-MM-DD") {
    return `${year}-${month}-${day}`;
  } else {
    return `${day}-${month}-${year} `;
  }
};

const formatDateYYYYMMDDThhmmss = (date) => {
  const selectedDate = new Date(date);
  const day = String(selectedDate.getDate()).padStart(2, "0");
  const month = String(selectedDate.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const year = selectedDate.getFullYear();

  let hours = selectedDate.getHours();
  let minutes = selectedDate.getMinutes();
  let seconds = selectedDate.getSeconds();

  hours = hours.toString().padStart(2, "0");
  minutes = minutes.toString().padStart(2, "0");
  seconds = seconds.toString().padStart(2, "0");

  return date ? `${year}-${month}-${day}T${hours}:${minutes}:${seconds}` : null;
};

const getRole = () => {
  return getSession(window, constants.SS_KEY_GROUP_USER_ROLE);
  // return decryptData(getSession(window, constants.SS_KEY_GROUP_USER_ROLE));
};

const getEmail = () => {
  return getSession(window, constants.SS_KEY_GROUP_USER_EMAIL);

  // return decryptData(getSession(window, constants.SS_KEY_GROUP_USER_EMAIL));
};
export default {
  encryptData,
  decryptData,
  encryptObject,
  decryptObject,
  handleLogOut,
  validateAPI,
  formatDateYYYYMMDDThhmmss,
  formatDateTime,
  formatDate,
  priorityList,
  getRole,
  getEmail,
};
